import { Component, ChangeDetectionStrategy, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { IMAGE_HERO_URL, VAR_BORDER_RADIUS, URL_HERO_FOLDER } from '@ux/components/image/constants/image-type.constants';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { ImageDimensionPipe } from '@app/pipes/image-dimension.pipe';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ImageComponent implements OnInit {

  @Input() type: string;
  @Input() borderRadius: number;
  @Input() customNoImage: string = null;
  @Input() dimension: string = null;
  @Input() supportSrcSet: boolean = false;
  @Input() maxHeight: number = null;
  @Input() borderRadiusOnlyTop: boolean = false;

  @Input()
  set src(value: string) {
    this._src = value;
    this.setSrcImage();
  }
  get src(): string {
    return this._src;
  }

  @Input()
  set borderTopLeftRadius(borderTopLeftRadius: number) {
    this._borderTopLeftRadius = borderTopLeftRadius;
    this.setStyleImage();
  }
  get borderTopLeftRadius(): number | null {
    return this._borderTopLeftRadius;
  }

  @Input()
  set borderTopRightRadius(borderTopRightRadius: number) {
    this._borderTopRightRadius = borderTopRightRadius;
    this.setStyleImage();
  }
  get borderTopRightRadius(): number | null {
    return this._borderTopRightRadius;
  }

  @Output() clickImage: EventEmitter<void> = new EventEmitter<void>();
  @Output() errorImage: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _src: string;
  private _borderTopLeftRadius: number | null = null;
  private _borderTopRightRadius: number | null = null;

  public ngStyle: { [key: string]: string };
  public srcImage: string;

  constructor(
    private imageCdnPipe: ImageCdnPipe,
    private imageDimensionPipe: ImageDimensionPipe) {
  }

  public get srcSet(): string {
    const index = this.src.lastIndexOf('.');
    const imageUrl = this.src;
    const path = imageUrl.slice(0, index);
    const extension = imageUrl.slice(index);
    const imageList = [
      imageUrl, `${path}@2x${extension} 2x`, `${path}@3x${extension} 3x`
    ];
    return imageList.join(', ');
  }

  ngOnInit(): void {
    this.setStyleImage();
    this.setSrcImage();
  }

  public getBorderRadiusValue(topLeft: boolean, topRight: boolean): number {
    return topLeft ? this.borderTopLeftRadius : topRight ? this.borderTopRightRadius : this.borderRadius;
  }

  public setSrcImage(): void {
    this.srcImage = this.urlImageDimension(this.src, this.dimension);
  }

  public urlSrcHttpImage(): string {
    return this.src ? this.src.replace(/^http:\/\//i, 'https://') : this.src;
  }

  public setStyleImage(): void {
    this.ngStyle = {};
    if (!this.borderRadiusOnlyTop) {
      this.ngStyle['border-bottom-left-radius'] = `var(--${VAR_BORDER_RADIUS}-${this.getBorderRadiusValue(false, false)})`;
      this.ngStyle['border-bottom-right-radius'] = `var(--${VAR_BORDER_RADIUS}-${this.getBorderRadiusValue(false, false)})`;
    }
    this.ngStyle['border-top-left-radius'] = `var(--${VAR_BORDER_RADIUS}-${
      this.getBorderRadiusValue(!isNullOrUndefined(this.borderTopLeftRadius), false)
    })`;
    this.ngStyle['border-top-right-radius'] = `var(--${VAR_BORDER_RADIUS}-${
      this.getBorderRadiusValue(false, !isNullOrUndefined(this.borderTopRightRadius))
    })`;
    if (!isNullOrUndefined(this.maxHeight)) this.ngStyle['height'] = `${this.maxHeight}px`;
  }

  public urlImage(name: string): string {
    if (this.customNoImage) return this.imageCdnPipe.baseImage(name, '');
    return this.imageCdnPipe.baseImage(name, URL_HERO_FOLDER);
  }

  public urlImageDimension(url: string, dimension: string): string {
    return dimension ?
      this.imageDimensionPipe.transform(url, dimension) : url;
  }

  public errorHandler(): void {
    this.supportSrcSet = false;
    this.srcImage = this.urlImage(this.customNoImage || IMAGE_HERO_URL[this.type]);
    this.errorImage.emit(true);
  }
}
